import React from 'react';
import {Col, Button} from 'react-bootstrap';
import FieldGroup from '../../../components/FieldGroup';

class SearchWaitlist extends React.Component {
  handleSubmit(e){
    e.preventDefault();
    this.props.submitSearch();
  }
  render(){
    return(
      <Col md={6} style={{display: 'flex'}}>
        <form onSubmit={this.handleSubmit.bind(this)} style={{flex: 1, display: 'flex'}}>
          <FieldGroup
            id="formControlsName"
            type="text"
            label="Name"
            placeholder="Enter name"
            name="name"
            value={this.props.searchValue}
            onChange={(e)=>this.props.updateSearch(e.target.value)}
            style={{flex: 1}}
          />
          <Button
            disabled={this.props.searchValue.length == 0}
            type="submit"
            style={{margin: 'auto', marginLeft: '20px'}}
          >
            Submit
          </Button>
        </form>
      </Col>
    )
  }
}

export default SearchWaitlist;
